import { FunctionComponent } from 'react';
import { Footer } from '@gaiads/telia-react-component-library';

import { SameTabLinkAdapter } from '@cdaas/reusable-components-daas';
import { EMAIL_TITLE, EMAIL_TO, PHONE_NUMBER_TITLE, PHONE_NUMBER_TO } from '../../../utils/constants';

const ShopFooter: FunctionComponent = () => {
  return (
    <Footer
      links={[
        {
          to: EMAIL_TO,
          title: EMAIL_TITLE,
          linkAdapter: SameTabLinkAdapter,
        },
        {
          to: PHONE_NUMBER_TO,
          title: PHONE_NUMBER_TITLE,
          linkAdapter: SameTabLinkAdapter,
        },
      ]}
    />
  );
};

export default ShopFooter;
